export default __webpack_public_path__ + "static/media/46_engel.c3cbc2f8.png";